
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function SpellSlotTypeIndex() {
  return (
    <NonFSIndex
      data_type="spell_slot_type"
      // save_all
    />
  );
}
